import React from 'react'
import styled from 'styled-components'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const ChartCounterIcon = () => (
  <IconContainer>
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="40" viewBox="0 0 72 40">
      <text className="fillHoverSVG" id="chart_1234" transform="translate(36 32)" fill="#707070" fontSize="31" fontFamily="Roboto-Black, Roboto" fontWeight="800">
        <tspan x="-35.904" y="0">1234</tspan>
      </text>
    </svg>
  </IconContainer>
)

export default ChartCounterIcon